import {
  ADMIN,
  ADMINISTRATIVE,
  ADMINISTRATOR,
  COACH,
  EX_MEMBER,
  FRONTDESK,
  LEAD,
  MEMBER,
  NON_MEMBER,
  StaffRole,
  SUPERUSER,
} from "../types/roles";

const ROLE_ORDER = {
  [NON_MEMBER]: 1,
  [LEAD]: 2,
  [EX_MEMBER]: 3,
  [MEMBER]: 4,
  [FRONTDESK]: 5,
  [ADMINISTRATIVE]: 5,
  [COACH]: 6,
  [ADMIN]: 7,
  [ADMINISTRATOR]: 7,
  [SUPERUSER]: 8,
} as const;

/**
 * Checks if a user has at least the specified role level
 * @param userRole The user's role
 * @param requiredRole The minimum role level required
 * @returns boolean indicating if user meets the minimum role requirement
 */
export const hasAtLeastRole = ({
  userRole,
  requiredRole,
}: {
  userRole: StaffRole;
  requiredRole: StaffRole;
}): boolean => {
  const userRoleLevel = ROLE_ORDER[userRole];
  const requiredRoleLevel = ROLE_ORDER[requiredRole];

  return userRoleLevel >= requiredRoleLevel;
};
